var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBgHome1Bl({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 332,
    height: 350,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ACF6E4",
    d: "M101.557 173.761c-26.718 2.453-13.921 29.57 11.351 31.385 6.193-16.968 3.609-32.758-11.351-31.385Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#0E0E2C",
    strokeLinecap: "square",
    strokeWidth: 6,
    d: "M-1.339 192.313c80.954 128.39 147.883-22.681 102.896-18.552-32.634 2.996-6.316 42.788 29.682 28.326 26.31-10.57 31.813-27.958 36.703-54.052 4.888-26.083 14.192-42.547 37.519-57.52 18.577-11.923 33.622-16.819 54.56-21.128"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "darken",
      fill: "#77c69b",
      fillOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("ellipse", {
    fill: "#ACF6E4",
    rx: 66.891,
    ry: 115.431,
    style: {
      fill: "#77c69b",
      fillOpacity: 1
    },
    transform: "matrix(-.83787 -.5464 .54658 -.83707 120.981 186.565)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgHome1Bl);
export default __webpack_public_path__ + "static/media/bg_home1_bl.ef21b8f9432fe4c7dc6fefb6f0c2f974.svg";
export { ForwardRef as ReactComponent };